import React from 'react';
import { scrollToSection } from '../lib/scroll';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand text-white py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Logo and Description */}
          <div>
            <img
              src="/images/logo-horizontal-blanco.png"
              alt="Andes Metal"
              className="h-10 mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Excelencia en metalmecánica industrial con más de 30 años de experiencia en Mendoza, Argentina.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <a href="tel:+5492616558544" className="hover:text-white transition-colors duration-300">
                  +54 261 655 8544
                </a>
              </li>
              <li>
                <a href="mailto:ventas@andesmetal.com" className="hover:text-white transition-colors duration-300">
                  ventas@andesmetal.com
                </a>
              </li>
              <li>Mendoza, Argentina</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Andes Metal. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
